import { Navigate } from 'react-router-dom';

// Public Route for all users
export const PublicRoute = (
    props
) => {

let isLoggedIn = props.isLoggedIn


    return (
        ( !isLoggedIn )
            ? props.children
            : ( <Navigate to="/home" /> )
    )
}
